import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { hide as _hide, show as _show } from '../utils/style';
import { Node } from './node';
import { defineProps } from './define';
import { compositionProps } from './props';
var CompositionNode = /*#__PURE__*/function (_Node) {
  _inherits(CompositionNode, _Node);
  function CompositionNode() {
    _classCallCheck(this, CompositionNode);
    return _possibleConstructorReturn(this, _getPrototypeOf(CompositionNode).apply(this, arguments));
  }
  _createClass(CompositionNode, [{
    key: "changeData",
    /**
     * Change current node data and its children data.
     */
    value: function changeData(data) {
      var _a;
      var chart = this.getRoot();
      if (!chart) return;
      this.attr('data', data);
      if ((_a = this.children) === null || _a === void 0 ? void 0 : _a.length) {
        this.children.forEach(function (child) {
          child.attr('data', data);
        });
      }
      return chart === null || chart === void 0 ? void 0 : chart.render();
    }
    /**
     * Get view instance by key.
     */
  }, {
    key: "getView",
    value: function getView() {
      var _this = this;
      var chart = this.getRoot();
      var _chart$getContext = chart.getContext(),
        views = _chart$getContext.views;
      if (!(views === null || views === void 0 ? void 0 : views.length)) return undefined;
      return views.find(function (view) {
        return view.key === _this._key;
      });
    }
  }, {
    key: "getScale",
    value: function getScale() {
      var _a;
      return (_a = this.getView()) === null || _a === void 0 ? void 0 : _a.scale;
    }
  }, {
    key: "getScaleByChannel",
    value: function getScaleByChannel(channel) {
      var scale = this.getScale();
      if (scale) return scale[channel];
      return;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      var _a;
      return (_a = this.getView()) === null || _a === void 0 ? void 0 : _a.coordinate;
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      var _a;
      return (_a = this.getView()) === null || _a === void 0 ? void 0 : _a.theme;
    }
  }, {
    key: "getGroup",
    value: function getGroup() {
      var key = this._key;
      if (!key) return undefined;
      var chart = this.getRoot();
      var chartGroup = chart.getContext().canvas.getRoot();
      return chartGroup.getElementById(key);
    }
    /**
     * Show the view.
     */
  }, {
    key: "show",
    value: function show() {
      var group = this.getGroup();
      if (!group) return;
      !group.isVisible() && _show(group);
    }
    /**
     * Hide the view.
     */
  }, {
    key: "hide",
    value: function hide() {
      var group = this.getGroup();
      if (!group) return;
      group.isVisible() && _hide(group);
    }
  }]);
  return CompositionNode;
}(Node);
CompositionNode = __decorate([defineProps(compositionProps)], CompositionNode);
export { CompositionNode };